import Barba from '@barba/core';

export default function () {
    const button = document.querySelector('#phone-us-button');
    button.classList.remove('open');

    // Barba.hooks.beforeLeave(() => {
    //     button.removeEventListener('click', toggleButton);
    // })

    // Barba.hooks.beforeEnter(() => {
    //     button.removeEventListener('click', toggleButton);
    // })

    button.addEventListener('click', toggleButton)

    function toggleButton (e) {
        if (e.target.nodeName !== 'A') {
            console.log(e.target.nodeName)
            button.classList.toggle('open');
        }
    }
}